export class FunnelConfig {
  assignedColors: any[];
  constructor(assignedColors: Array<string>) {
    this.assignedColors = assignedColors;
  }
}